module.exports = __webpack_public_path__ + "img/icmcrypto-trader.747cd946.png";